<template>
    <div id="camp-card" class="camp-prev">
        <div class="camp-prev-content mx-auto">
            <div class="position-relative camp-prev-content-header">
                <div v-if="previewData.crosspromoter" class="badge">
                    <Icon v-b-tooltip.hover title="Active Crosspromoter" icon="badge" class="active-cp-badge"/>
                </div>
                <div class="camp-icons position-absolute d-flex flex-column justify-content-end">
                    <Favorite 
                        favorite-location="Campaign Page"
                        class="heart-icon"
                        v-if="previewData && previewData.id"
                        :card-data="previewData"/>
                    <router-link
                        v-if="$route.query.model === 'drafts' && !$route.path.includes('preview')"
                        :to="{path:'/wizard/edit-campaign', query: {id: $route.params.campaignID}}"
                        id="edit-campaign-link-drafts"
                        class="mt-1 p-0">
                            <EditIcon/>
                    </router-link>
                    <router-link 
                        v-if="($route.query.model === 'campaigns' || !$route.query.model) && user.uid === previewData.author_id && !$route.path.includes('preview')"
                        :to="{path:'/edit-campaign', query: {id: $route.params.campaignID, model: 'campaigns'}}"
                        id="edit-campaign-link-publish"
                        class="mt-1 p-0">
                            <EditIcon/>
                    </router-link>
                </div>
                <Thumbnail
                    size="original"
                    :data = "previewData"
                    class-name = "w-100" />
                <div class="prev-info position-absolute d-flex justify-content-between w-100 px-2">
                    <div>
                        <p class="lab c16 mb-0">backers</p>
                        <p id="backers-count" class="p2bl c16 mb-0">{{previewData.backers}}</p>
                    </div>
                    <div class="d-flex align-items-center">
                        <div v-if="hasStatus" data-name="product-status">
                            <Icon :icon="previewData.indemand ? 'in-demand-status' : 'live-status'"/>
                            <p class="mb-0 text-capitalize">{{previewData.indemand ? 'InDemand' : previewData.state}}</p>
                        </div>
                        <a
                            :href="previewData.project_url"
                            target="_blank"
                            id="project-url"
                            @click="toProject"
                            class="ks-link">
                                <Kickstarter 
                                    v-if="previewData.platform === 'kickstarter'"
                                    v-b-tooltip.hover 
                                    title="Opens in a new window."/>
                        </a>
                        <!-- <Indiegogo v-else/> -->
                    </div>
                </div>
            </div>
            <div class="camp-prev-body mt-2 d-flex flex-column justify-content-between">
                <div class="camp-title">
                    <p id="campaign-title" class="c8 mb-0">{{previewData.title}}</p>
                    <p id="campaign-desc" class="c7 mb-2">{{previewData.description }}</p>
                </div>
                <div class="camp-category-info pt-1">
                    <div class="d-flex justify-content-between">
                        <div v-if="daysToGo" class="d-flex align-items-center">
                            <Daystogo/>
                            <p id="days-to-go" class="lab c3 mb-0 pl-1">{{daysToGo}} days left</p>
                        </div>
                        <div>
                            <p class="lab c6 mb-0">Category</p>
                            <p id="campaign-category" class="lab c3 mb-0"> {{previewData.category}} </p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <p class="lab c6 mb-0">Tags</p>
                            <div class="d-flex tags-group justify-content-start flex-wrap">
                                <p v-for="(tag, index) in previewData.tags"
                                    :key="`tag-${index}`" 
                                    :id="`tag-${index}-${tag}`"
                                    class="lab c3 mb-0 mr-3">
                                    {{tag}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { 
    Kickstarter, 
    Indiegogo, 
    Favorite, 
    Daystogo, 
    EditIcon, 
    DeleteIcon 
} from '../../Icons'
import Icon from '../../Theme/Icon'
import Thumbnail from '../../Theme/Thumbnail'
    export default {
        name: "CampCard",
        components: {
            Kickstarter,
            Indiegogo,
            Favorite,
            Daystogo,
            EditIcon,
            DeleteIcon,
            Icon,
            Thumbnail
        },
    
    computed: {
        ...mapState([
            'user'
        ]),
        daysToGo(){
            if(this.previewData.state && this.previewData.state === 'ended') {
                return null
            }
            return this.previewData.daystogo > 0 && this.previewData.daystogo
        },
        hasStatus(){
            return this.previewData && this.previewData.state !== 'ended' || this.previewData.indemand
        }
    },
    props: {
        previewData: Object
    },
    methods: {
        toProject(){
            this.$ga.event('Campaign', 'KS Icon Click', `
                Location: Campaign Page Card,
                Campaign: ${this.previewData.title}
            `)
            
            this.$sendMixpanelEvent('KS Icon Clicked', {
                'KS Icon Location': 'Campaign Page Card',
                'Viewed Campaign': this.previewData.title
            });
        },
    }

}
</script>

<style scoped lang="scss">

@import '../../../assets/scss/variables.scss';
        div.camp-prev {
            height: 670px;
            max-width: 440px;
            padding: 36px;
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0px 0px 35px rgba(154, 161, 171, 0.15);
            border-radius: 10px;

            div.camp-prev-content {
                width: 360px;

                div.badge {
                    position: absolute;
                    z-index: 100;
                    top: 8px;
                    left: 8px;
                    transform: scale(1.2);
                    transition: all 0.2s ease;
                    &:hover {
                        transform: scale(1.3);
                    }
                }

                div.camp-prev-content-header {
                    min-height: 360px;

                    img.w-100 {
                        object-fit: cover;
                        height: 360px;
                        border-radius: 10px;
                    }
                }
                div.camp-icons {
                    right: 8px;
                    top: 8px;
                }

                div.prev-info {
                    height: 47px;
                    background: rgba(0, 0, 0, 0.9);
                    border-bottom-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                    bottom: 0;

                    div[data-name="product-status"] {
                        font-size: $p5;
                        font-weight: 300;
                        color: $c14;
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                        margin-right: 8px;
                        p {
                            margin-left: 6px;
                        }
                    }
                }

                div.camp-prev-body {
                    min-height: 225px;

                    div.camp-title {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 5;
                        overflow: hidden;
                        p {
                            &:first-child {
                                font-size: 18px;
                                font-weight: bold;
                                line-height: 23px;
                            }
                            &:last-child {
                                font-size: 16px;
                                line-height: 24px;
                                margin-top: 20px;
                            }
                        }
                    }
                    
                    div.camp-category-info {
                        div.tags-group {
                            p {
                                &:first-child {
                                    margin-left: 0 !important;
                                }
                            }
                        }
                        border-top: 1px solid #F4F4F4;

                    }
                }
            }
        }
</style>